import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmericanExpressIconCard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 16,
	viewBox: "0 0 24 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_260_35058)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4764 5.56629L10.4924 10.446H9.30237L10.2864 5.56629H11.4764ZM16.4938 8.71725L17.1231 6.8843L17.4835 8.71725H16.4938ZM17.8211 10.446H18.9253L17.9641 5.56629H16.9458C16.7169 5.56629 16.5224 5.70729 16.4366 5.92185L14.6516 10.446H15.9045L16.1562 9.71648H17.6838L17.8211 10.446ZM14.7088 8.85825C14.7145 7.57089 13.0268 7.49733 13.0382 6.92108C13.044 6.7433 13.1984 6.5594 13.5417 6.51035C13.7133 6.48583 14.1825 6.46744 14.7145 6.73104L14.9262 5.69503C14.6402 5.58468 14.2683 5.48047 13.8106 5.48047C12.6321 5.48047 11.8025 6.14254 11.7968 7.09273C11.791 7.79771 12.3918 8.19005 12.838 8.423C13.3014 8.66208 13.4616 8.81533 13.4559 9.02989C13.4559 9.3548 13.084 9.50192 12.7465 9.50805C12.1458 9.52032 11.7968 9.33641 11.5222 9.20154L11.3048 10.2682C11.5851 10.4031 12.1 10.5195 12.6321 10.5257C13.8907 10.5318 14.7088 9.87587 14.7088 8.85825ZM9.77722 5.57242L7.84349 10.4521H6.58485L5.63515 6.5594C5.57794 6.32032 5.52645 6.23449 5.35482 6.13028C5.06304 5.96476 4.58819 5.8115 4.17627 5.71342L4.20487 5.57242H6.23014C6.48759 5.57242 6.72216 5.75633 6.77937 6.06897L7.28282 8.89503L8.5243 5.57242H9.77722Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.45752 1.72873C0.45752 0.956315 1.04107 0.337158 1.75621 0.337158H22.2492C22.97 0.337158 23.5479 0.962445 23.5479 1.72873V14.2651C23.5479 15.0375 22.9643 15.6567 22.2492 15.6567H1.75621C1.03535 15.6567 0.45752 15.0314 0.45752 14.2651V1.72873Z",
				fill: "#3C404B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.8092 7.85286C12.8092 9.73485 11.3561 11.2613 9.55964 11.2613C7.76322 11.2613 6.31006 9.73485 6.31006 7.85286C6.31006 5.97086 7.76322 4.44443 9.55964 4.44443C11.3561 4.44443 12.8092 5.97086 12.8092 7.85286Z",
				fill: "#F26436"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.6837 7.85286C17.6837 9.73485 16.2306 11.2613 14.4342 11.2613C12.6377 11.2613 11.1846 9.73485 11.1846 7.85286C11.1846 5.97086 12.6377 4.44443 14.4342 4.44443C16.2306 4.44443 17.6837 5.97086 17.6837 7.85286Z",
				fill: "#FFC735"
			}),
			/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip1_260_35058)",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M21.9976 0.337097H2.00807C1.17851 0.337097 0.503418 1.04821 0.503418 1.93097V14.075C0.503418 14.9517 1.17851 15.6689 2.00807 15.6689H21.9976C22.8271 15.6689 23.5022 14.9578 23.5022 14.075V1.92484C23.4965 1.04821 22.8271 0.337097 21.9976 0.337097Z",
					fill: "#2478BB"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M4.77145 5.51718L2.64893 10.495H5.19481L5.50947 9.70415H6.23033L6.54499 10.495H9.34261V9.88806L9.59434 10.495H11.0418L11.2935 9.8758V10.495H17.1176L17.827 9.72254L18.4906 10.495L21.4771 10.5011L19.3431 8.01833L21.4713 5.51718H18.5307L17.8384 6.27733L17.1977 5.51718H10.8644L10.3209 6.79841L9.76597 5.51718H7.23152V6.10569L6.94547 5.51718H4.77145ZM5.26347 6.22829H6.50495L7.91234 9.60607V6.22829H9.26824L10.3552 8.64975L11.3564 6.22829H12.7066V9.80224H11.8828L11.8771 7.00071L10.6756 9.80224H9.9376L8.73045 7.00071V9.80224H7.03701L6.71663 8.99917H5.0003L4.67992 9.80224H3.77598L5.26347 6.22829ZM13.4675 6.22829H16.8086L17.8327 7.39917L18.8911 6.22829H19.9152L18.3591 8.02446L19.9152 9.79611H18.8454L17.8213 8.61297L16.7629 9.79611H13.4732V6.22829H13.4675ZM5.8699 6.82906L5.29779 8.25741H6.43629L5.8699 6.82906ZM14.2914 6.96392V7.61373H16.1164V8.3371H14.2914V9.04822H16.3395L17.2892 7.99994L16.3796 6.95779L14.2914 6.96392Z",
					fill: "white"
				})]
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_260_35058",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 16,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_260_35058",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 16,
			fill: "white"
		})
	})] })]
});
export default SvgAmericanExpressIconCard;
